var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClickSimulator',_vm._b({},'ClickSimulator',_vm.componentData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }